// Configuration file for StackIt frontend
// Update these values based on your deployment environment

const config = {
  // API Base URL - Update this after deploying your Cloudflare Worker
  API_BASE_URL: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5000'  // Local development URL
    : 'https://stackit-backend.officialchiragp1605.workers.dev',  // Your actual Worker URL
  
  // App Configuration
  APP_NAME: 'StackIt',
  APP_VERSION: '1.0.0',
  
  // Frontend Configuration
  PAGINATION_LIMIT: 10,
  SEARCH_DEBOUNCE_MS: 300,
  NOTIFICATION_TIMEOUT: 5000,
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/login',
    REGISTER: '/api/register',
    LOGOUT: '/api/logout',
    
    // Users
    USERS: '/api/users',
    USER_PROFILE: '/api/users/:id',
    USER_STATS: '/api/users/:id/stats',
    
    // Questions
    QUESTIONS: '/api/questions',
    QUESTION_DETAIL: '/api/questions/:id',
    TRENDING_QUESTIONS: '/api/questions/trending',
    SIMILAR_QUESTIONS: '/api/questions/similar',
    
    // Answers
    ANSWERS: '/api/answers',
    QUESTION_ANSWERS: '/api/questions/:id/answers',
    ANSWER_VOTE: '/api/answers/:id/vote',
    
    // Search
    SEARCH: '/api/search',
    SMART_SEARCH: '/api/search/smart',
    
    // AI Features
    SUGGEST_TAGS: '/api/ai/suggest-tags',
    ANALYZE_CONTENT: '/api/ai/analyze-content',
    RECOMMENDATIONS: '/api/ai/recommendations',
    
    // Notifications
    NOTIFICATIONS: '/api/notifications',
    MARK_NOTIFICATION_READ: '/api/notifications/:id/read',
    
    // Moderation
    FLAG_CONTENT: '/api/moderation/flag',
    ADMIN_DASHBOARD: '/api/admin/dashboard'
  },
  
  // Feature Flags
  FEATURES: {
    SMART_SEARCH: true,
    AI_RECOMMENDATIONS: true,
    MEDAL_SYSTEM: true,
    NOTIFICATIONS: true,
    CONTENT_MODERATION: true,
    ANSWER_SUMMARIZATION: true
  }
};

// Helper function to build full API URL
export const buildApiUrl = (endpoint, params = {}) => {
  let url = config.API_BASE_URL + endpoint;
  
  // Replace URL parameters
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function to get endpoint
export const getEndpoint = (name) => {
  return config.ENDPOINTS[name] || '';
};

// Helper function to check if feature is enabled
export const isFeatureEnabled = (feature) => {
  return config.FEATURES[feature] === true;
};

export default config; 